import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

type RepostContentObjectRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  post: {
    html_content?: string;
    post_in_communities: [{ id: string }];
    shared_content_object_id: string;
    text_content?: string;
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const repostContentObject = async (data: RepostContentObjectRequest) =>
  apiClient.post<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.create,
    data,
  );
